import { LivePlayer } from "@/components/live";
import { LiveDetailData } from "@/types";
import useNavigation from "@/utils/useNavigate";
import { TrackData } from "@akc/taro-service";
import { FloatingBubble } from "antd-mobile";
import moment from "moment";
import React, { useEffect } from "react";
import styles from "./index.module.less";

interface Props {
  visible?: boolean;
  liveSimpleVO: LiveDetailData;
  trackData?: TrackData;
  // 进入直播间埋点
  onEnterLiveTrack?: (trackOpts) => void;
}

// 悬浮直播小窗组件
const LiveSmallWindow: React.FC<Props> = ({
  visible = true,
  liveSimpleVO,
  trackData,
  onEnterLiveTrack,
}) => {
  const { navigate2LiveRoom, navigate2PreheatLiveRoom } = useNavigation();
  if (!liveSimpleVO?.liveNo) {
    return null;
  }

  // 点击跳转直播
  const handleJumpPage = () => {
    if (!liveSimpleVO?.liveNo) {
      return;
    }
    onEnterLiveTrack?.({
      // page_name: "店铺特卖",
      // previous_page_name,
      // merchant_shop_code: merchantShopCode,
      // resource_type: "",
      // resource_content: "",
      domain: "直播小窗",
      live_status:
        liveSimpleVO?.liveStatus === 20
          ? "直播中"
          : liveSimpleVO?.liveStatus === 10
            ? "直播预告"
            : "直播结束",
      live_no: liveSimpleVO?.liveNo,
      live_name: liveSimpleVO?.liveTitle,
      live_type: liveSimpleVO?.liveType,
      btn_name: "进入直播",
    });
    if (liveSimpleVO?.liveStatus === 10) {
      // 预告状态
      navigate2PreheatLiveRoom({
        liveId: liveSimpleVO?.liveNo,
      });
    } else if (liveSimpleVO?.liveStatus === 20) {
      // 直播中状态
      navigate2LiveRoom({
        liveId: liveSimpleVO?.liveNo,
      });
    }
  };

  return (
    <>
      <FloatingBubble
        axis="xy"
        magnetic="x"
        style={{
          "--initial-position-top": "160px",
          "--initial-position-right": "12px",
          "--edge-distance": "12px",
          "--border-radius": "6px",
          "--size": "3rem 1.1rem",
          "--background": "transparent",
          "--z-index": "500",
          display: visible ? "block" : "none",
        }}>
        <div
          className={`${styles.live_small_window} ${liveSimpleVO?.liveStatus === 10 ? styles.feature : ""}`}
          onClick={handleJumpPage}>
          <div className={styles.window__body}>
            {/* 直播播放器 */}
            <LivePlayer
              roomId={liveSimpleVO.liveNo}
              className={styles.live}
              muted={true}
              onError={error => {
                console.log("播放器报错", error);
              }}
              poster={liveSimpleVO?.coverUrl}
              src={liveSimpleVO?.pullStreamUrl?.httpM3u8Url}
              supportClick={false}
              mutedVisible={false}
              showPlayBtn={false}
              trackData={trackData}
              liveInfo={{
                liveStatus: liveSimpleVO?.liveStatus,
                liveNo: liveSimpleVO?.liveNo,
                liveTitle: liveSimpleVO?.liveTitle,
                liveType: liveSimpleVO?.liveType,
              }}
            />
            {liveSimpleVO?.liveStatus === 10 ? (
              <div className={styles.feature__text}>直播预告</div>
            ) : null}
          </div>

          <div className={styles.window__footer}>
            {liveSimpleVO?.liveStatus === 10 ? (
              <div className={styles.footer__date}>
                <div className={styles.data__day}>
                  {liveSimpleVO?.planBeginTime
                    ? moment(Number(liveSimpleVO.planBeginTime)).format("MM月DD日")
                    : ""}
                </div>
                <div className={styles.data__time}>
                  {liveSimpleVO?.planBeginTime
                    ? moment(Number(liveSimpleVO.planBeginTime)).format("HH:mm")
                    : ""}
                </div>
              </div>
            ) : null}
            {liveSimpleVO?.liveStatus === 20 ? (
              <div className={styles.footer__status}>正在直播</div>
            ) : null}
          </div>
        </div>
      </FloatingBubble>
    </>
  );
};

export default LiveSmallWindow;
